import { API_BASE_URL } from "@repo/api";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { MfeLoader } from "../../mfe/MfeLoader";

export const Route = createFileRoute("/integrations/universalOnboarding/$")({
  component: UniversalOnboardingMfePage,
});

function UniversalOnboardingMfePage() {
  const hostConfig = useMemo(
    () => ({
      apiBaseUrl: API_BASE_URL,
      basename: "/integrations/universalOnboarding",
    }),
    [],
  );

  return <MfeLoader name="universal-onboarding" props={{ hostConfig }} />;
}
